export default {
    USERS: '/users',
    RESOURCE_ACCOUNTS: '/resource-accounts',
    RESOURCE_ACCOUNTS_ENDPOINT: '/resourceAccounts',
    BUILDER: 'builder',
    CSVUSERS: 'csv-users',
    CSVUSERCREATE: 'csv-create',
    CSVRESOURCEACCOUNTS: 'csv-resource-accounts',
    CSVRINGGROUPMEMBERSHIP: 'csv-ringgroup-membership',
};
